import type { SettingsColumnHead } from '@/modules/settings';

/** The Escalations log's column titles, rendered in the page's sticky header. */
export const ESCALATION_LOG_COLUMNS: SettingsColumnHead[] = [
	{ id: 'at', header: 'Date & time', className: 'w-[160px]' },
	{ id: 'status', header: 'Status', className: 'w-[150px]' },
	{ id: 'ticket', header: 'Ticket ID', className: 'w-[110px]' },
	{ id: 'action', header: 'Action', className: 'w-[170px]' },
	// TODO: show once the escalation log stores the recipient; the backend has no field for it yet.
	// { id: 'to', header: 'Escalated to', className: 'w-[200px]' },
	{ id: 'content', header: 'Escalation content' }
];
